import { useAuth0 } from '@auth0/auth0-react'
import { useAccessToken } from 'hooks/useAccessToken/useAccessToken'
import React, { useCallback, useEffect, useState } from 'react'

import useLoggedNavigate from 'hooks/useLoggedNavigate'

export default () => {
  const navigate = useLoggedNavigate()
  const { isAuthenticated } = useAuth0()
  const accessToken = useAccessToken()

  useEffect(() => {
    ;(async () => {
      const loggedIn = isAuthenticated
      if (!loggedIn) {
        if (typeof window !== 'undefined') {
          const postLogin = `PostLoginURL=${encodeURIComponent(
            `/ReceiptDownloader${window.location.search}`
          )}`
          navigate(`/login?${postLogin}`)
        }
      } else if (accessToken) {
        if (typeof window !== 'undefined') {
          const urlParams = new URLSearchParams(window.location.search)
          const invoiceNumber = urlParams.get('InvoiceNumber')

          const token = accessToken

          window.location.href = `${process.env.REACT_APP_API_URL}/receipts/${invoiceNumber}?authToken=${token}&download=true`
        }
      }
    })()
  }, [accessToken, isAuthenticated])

  return <></>
}
